var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDhl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 30,
    viewBox: "0 0 48 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dhl-1 1",
    clipPath: "url(#clip0_1_3604)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.979248 0H47.9982V30H0.979248V0Z",
    fill: "#FFCB01"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.71664 11.4209L8.26062 13.3993H16.1962C16.5975 13.3993 16.5925 13.5504 16.3963 13.8176C16.1972 14.0878 15.8639 14.5551 15.6608 14.8303C15.5577 14.9694 15.3716 15.2226 15.988 15.2226H19.2333L20.195 13.9156C20.7914 13.1061 20.247 11.4219 18.1145 11.4219L9.71664 11.4209Z",
    fill: "#D80613"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.67121 17.8664L10.5963 13.8916H14.2258C14.6271 13.8916 14.6221 14.0437 14.4259 14.3099L13.6854 15.3186C13.5823 15.4577 13.3962 15.7109 14.0126 15.7109H18.8741C18.4708 16.2653 17.1578 17.8664 14.8042 17.8664H7.67121ZM24.4209 15.7099L22.8348 17.8664H18.6509L20.237 15.7099H24.4209ZM30.8294 15.2216H20.5973L23.3952 11.4209H27.5771L25.974 13.6004H27.8403L29.4455 11.4209H33.6274L30.8294 15.2216ZM30.4702 15.7099L28.8841 17.8664H24.7021L26.2882 15.7099H30.4702ZM1.70203 16.5605H7.86434L7.52811 17.0178H1.70203V16.5605ZM1.70203 15.7099H8.49078L8.15354 16.1672H1.70203V15.7099ZM1.70203 17.4111H7.2389L6.90367 17.8664H1.70203V17.4111ZM47.2769 17.0178H41.1366L41.4739 16.5605H47.2769V17.0178ZM47.2769 17.8664H40.5132L40.8474 17.4111H47.2769V17.8664ZM42.0993 15.7099H47.2769V16.1682H41.7631L42.0993 15.7099ZM39.4194 11.4209L36.6215 15.2216H32.1894L34.9893 11.4209H39.4194ZM31.8311 15.7099C31.8311 15.7099 31.5259 16.1282 31.3768 16.3283C30.8524 17.0388 31.3158 17.8654 33.03 17.8654H39.7467L41.3328 15.7099H31.8311Z",
    fill: "#D80613"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3604"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.0219,
    height: 30,
    fill: "white",
    transform: "translate(0.978027)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDhl);
export default __webpack_public_path__ + "static/media/dhl.499e13a57d5cf63ae7d32bb882451332.svg";
export { ForwardRef as ReactComponent };